import {
    OpenAPI,
    ProductSalesService
} from '../openapi';
import { ApiResult } from '../openapi/core/ApiResult';

const { getSalesView } = ProductSalesService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getProductSales = async (token: string, range: string, filter?: Record<string, string>, search?: Record<string, string>) => {
    const sales: ApiResult = await getSalesView(token, range, filter, search);
    return sales;
};
